import React, { useState, useEffect } from 'react';

// 8 different exercise silhouettes with animation phases
const FIGURES = [
  { // Squat
    id: 'squat', x: 8, y: 20,
    pose: (p) => {
      const k = p ? 68 : 50;
      const h = p ? 46 : 58;
      const t = p ? 22 : 34;
      return `M50,90 L50,${k} L50,${h} L50,${t} M50,${t-8} a5,5 0 1,0 0.1,0 M50,${t+2} L38,${t+5} M50,${t+2} L62,${t+5} M42,90 L42,${k} L50,${h} M58,90 L58,${k} L50,${h}`;
    }
  },
  { // Deadlift
    id: 'deadlift', x: 28, y: 55,
    pose: (p) => {
      const bend = p ? 30 : 55;
      return `M50,90 L50,70 L50,60 L50,${bend} M50,${bend-8} a5,5 0 1,0 0.1,0 M50,${bend+8} L40,${p?50:75} M50,${bend+8} L60,${p?50:75} M42,90 L45,70 L50,60 M58,90 L55,70 L50,60`;
    }
  },
  { // Pull-up
    id: 'pullup', x: 52, y: 10,
    pose: (p) => {
      const by = p ? 25 : 45;
      return `M30,8 L70,8 M40,8 L${p?45:40},${by-5} M60,8 L${p?55:60},${by-5} M50,${by} a5,5 0 1,0 0.1,0 M50,${by+8} L50,${by+28} M50,${by+28} L44,${by+46} M50,${by+28} L56,${by+46}`;
    }
  },
  { // Lunge
    id: 'lunge', x: 75, y: 35,
    pose: (p) => {
      const fk = p ? 62 : 72;
      const hip = p ? 42 : 52;
      return `M35,90 L35,${fk} L50,${hip} M65,90 L60,${p?72:78} L50,${hip} M50,${hip} L50,${hip-20} M50,${hip-28} a5,5 0 1,0 0.1,0 M50,${hip-14} L38,${hip-10} M50,${hip-14} L62,${hip-10}`;
    }
  },
  { // Push-up
    id: 'pushup', x: 15, y: 72,
    pose: (p) => {
      const armY = p ? 70 : 80;
      return `M20,${armY} L25,${armY-5} L75,${p?68:75} M75,${p?68:75} L80,90 M75,${p?68:75} L70,90 M25,${armY-5} L25,${armY+5} M50,${p?64:72} a4,4 0 1,0 0.1,0`;
    }
  },
  { // Jumping Jack
    id: 'jack', x: 88, y: 65,
    pose: (p) => {
      const spread = p ? 18 : 2;
      const armY = p ? 15 : 45;
      return `M${50-spread},90 L${50-spread/2},65 L50,50 M${50+spread},90 L${50+spread/2},65 L50,50 M50,50 L50,28 M50,20 a5,5 0 1,0 0.1,0 M50,32 L${50-spread-5},${armY} M50,32 L${50+spread+5},${armY}`;
    }
  },
  { // Bicep Curl
    id: 'curl', x: 42, y: 82,
    pose: (p) => {
      const forearm = p ? 38 : 62;
      return `M45,90 L45,70 L50,58 M55,90 L55,70 L50,58 M50,58 L50,30 M50,22 a5,5 0 1,0 0.1,0 M50,36 L42,48 L40,${forearm} M50,36 L58,48 L60,${forearm}`;
    }
  },
  { // Plank
    id: 'plank', x: 62, y: 88,
    pose: (p) => {
      const dip = p ? 2 : 0;
      return `M20,65 L25,${55+dip} L80,${55+dip} M80,${55+dip} L85,70 M80,${55+dip} L75,70 M25,${55+dip} L20,70 M40,${50+dip} a4,4 0 1,0 0.1,0`;
    }
  },
];

function AnimatedFigure({ figure, delay }) {
  const [phase, setPhase] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => setPhase(p => !p), 1400 + delay * 200);
    return () => clearInterval(interval);
  }, [delay]);

  return (
    <svg
      viewBox="0 0 100 100"
      className="absolute"
      style={{
        left: `${figure.x}%`,
        top: `${figure.y}%`,
        width: '60px',
        height: '60px',
        opacity: 0.06,
        transform: `translate(-50%, -50%) scale(${0.8 + delay * 0.1})`,
      }}
    >
      <path
        d={figure.pose(phase)}
        fill="none"
        stroke="#8B5CF6"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ transition: 'all 0.8s ease-in-out' }}
      />
    </svg>
  );
}

export default function AnimatedBackground() {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" aria-hidden="true">
      {FIGURES.map((fig, i) => (
        <AnimatedFigure key={fig.id} figure={fig} delay={i} />
      ))}
    </div>
  );
}
